/** * * Asynchronously loads the component for
Login
* */ import { lazyLoad } from "utils/loadable";
export const Signin = lazyLoad(
  () => import("./index"),
  (module) => module.Signin
);